var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDice6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 103 103",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 99,
    height: 99,
    rx: 14,
    fill: "#EAF0FF",
    stroke: "#363636",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8281,
    cy: 24.8281,
    r: 10.8281,
    fill: "#363636"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1723,
    cy: 24.8281,
    r: 10.8281,
    fill: "#363636"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8281,
    cy: 51.8984,
    r: 10.8281,
    fill: "#363636"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8281,
    cy: 51.8984,
    r: 10.8281,
    fill: "#363636"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8281,
    cy: 78.9687,
    r: 10.8281,
    fill: "#363636"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1723,
    cy: 78.9687,
    r: 10.8281,
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice6);
export default __webpack_public_path__ + "static/media/Dice6.aa577c1f1ebf46fe39e1fccef59a5d3b.svg";
export { ForwardRef as ReactComponent };